import createAction from '../../services/create-action';
import { parseInstance } from '@wix/communities-forum-client-commons';

export const SET_INSTANCE_VALUES = 'instanceValues/SET';

export const setInstanceValues = createAction(SET_INSTANCE_VALUES);

export const initialiseInstanceValues = (instance) => (dispatch) =>
  dispatch(setInstanceValues(parseInstance(instance)));
